// Centralized phone/WhatsApp constants and helpers.
// Keep digits LTR via <bdi> when rendering inside RTL (Arabic) layouts.

export const PHONE_NATIONAL = "0504838870"; // Saudi national format
export const PHONE_E164 = "+966504838870"; // International dial string
export const PHONE_DISPLAY = "+966 50 483 8870"; // Human-readable, LTR
export const TEL_HREF = `tel:${PHONE_E164}`;

export const WHATSAPP_NUMBER = "966504838870"; // wa.me expects no +
export const buildWhatsAppUrl = (message?: string) =>
  `https://wa.me/${WHATSAPP_NUMBER}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
